/* UnTapped Mapleaid Hydration -- Volume "Build Your Box" floating popup.
   Loads site-wide but stays completely invisible until a customer adds any
   UnTapped product to cart from anywhere on the store. It then auto-opens,
   can be minimized to a launcher tab, or closed for the session. */
(function () {
  "use strict";
  if (window.__uwbMapleInit) return; window.__uwbMapleInit = true;

  var CONFIG = {
    handle: "untapped-mapleaid-hydration-80-count-box",
    vendor: "UnTapped",
    title: "UnTapped Mapleaid Hydration",
    basePrice: 9600, // cents
    image: "https://cdn.shopify.com/s/files/1/0682/2438/5114/files/Maple_Mapleaid_Pouring.webp?v=1765552174",
    // Fallback flavor set (refreshed live from /products/{handle}.js on load)
    flavors: [
      { name: "Original", id: 43599516270682, image: "https://cdn.shopify.com/s/files/1/0682/2438/5114/files/Maple_Mapleaid_Pouring.webp?v=1765552174" },
      { name: "Ginger",   id: 43599516303450, image: "https://cdn.shopify.com/s/files/1/0682/2438/5114/files/GMA-pouring-white.jpg?v=1765552158" },
      { name: "Lime",     id: 43599516336218, image: "https://cdn.shopify.com/s/files/1/0682/2438/5114/files/Lime_Mapleaid_Pouring.webp?v=1765400034" }
    ],
    // Stepped tiers (cents). No cap: top tier continues beyond its min.
    tiers: [
      { min: 1, price: 9600 },
      { min: 5, price: 8000 }
    ]
  };

  var PRODUCT_RX = /untapped\-mapleaid\-hydration\-80\-count\-box/i;

  var qty = {};            // variantId -> quantity
  CONFIG.flavors.forEach(function (f) { qty[f.id] = 0; });

  function money(c) {
    return "$" + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  function totalBoxes() {
    return CONFIG.flavors.reduce(function (s, f) { return s + (qty[f.id] || 0); }, 0);
  }
  function unitPriceFor(n) {
    var p = CONFIG.tiers[0].price;
    CONFIG.tiers.forEach(function (t) { if (n >= t.min) p = t.price; });
    return p;
  }
  function nextTier(n) {
    for (var i = 0; i < CONFIG.tiers.length; i++) {
      if (n < CONFIG.tiers[i].min) return CONFIG.tiers[i];
    }
    return null;
  }

  // ---- Build DOM ------------------------------------------------------------
  var root = document.getElementById("uwb-root-mapleaid");
  if (!root) return;
  root.hidden = true; // stay invisible until an UnTapped item is added to cart

  root.innerHTML =
    '<button class="uwb-dock" data-uwb-open>' +
      '\uD83D\uDCA7 Build your Mapleaid bundle' +
      '<span class="uwb-dock__count" data-uwb-dockcount>0</span>' +
    '</button>' +
    '<div class="uwb-panel" role="dialog" aria-label="Build your UnTapped Mapleaid bundle">' +
      '<div class="uwb-head">' +
        '<div class="uwb-eyebrow">Volume pricing \u00b7 mix any flavors</div>' +
        '<div class="uwb-title">Build your Mapleaid bundle</div>' +
        '<div class="uwb-head__btns">' +
          '<button class="uwb-iconbtn" data-uwb-min aria-label="Minimize">\u2013</button>' +
          '<button class="uwb-iconbtn" data-uwb-close aria-label="Close">\u00d7</button>' +
        '</div>' +
      '</div>' +
      '<div class="uwb-body">' +
      '<div class="uwb-progress">' +
        '<div class="uwb-progress__msg" data-uwb-msg></div>' +
        '<div class="uwb-bar"><div class="uwb-bar__fill" data-uwb-fill></div></div>' +
        '<div class="uwb-ticks">' +
          '<div class="uwb-tick" data-uwb-tick="1">' + money(9600) + '<span>1 80-pack</span></div>' +
          '<div class="uwb-tick" data-uwb-tick="5">' + money(8000) + '<span>5+ 80-packs</span></div>' +
        '</div>' +
      '</div>' +
      '<div class="uwb-listhead">Pick your flavors <span>Mix any \u2014 every 80-pack counts toward your tier</span></div>' +
      '<div class="uwb-list" data-uwb-list></div>' +
      '<div class="uwb-tiers" data-uwb-tiers>' +
        '<div class="uwb-tiers__label">Volume pricing</div>' +
      '</div>' +
      '</div>' +
      '<div class="uwb-foot">' +
        '<div class="uwb-mix" data-uwb-mix></div>' +
        '<div class="uwb-summary">' +
          '<div class="uwb-summary__boxes" data-uwb-boxes>0 80-packs</div>' +
          '<div class="uwb-summary__unit" data-uwb-unit></div>' +
        '</div>' +
        '<div class="uwb-savings" data-uwb-savings></div>' +
        '<button class="uwb-cta" data-uwb-view>View cart</button>' +
        '<div class="uwb-note">Volume discount applied automatically at checkout.</div>' +
        '<div class="uwb-toast" data-uwb-toast></div>' +
      '</div>' +
    '</div>';

  // Flavor rows
  var list = root.querySelector("[data-uwb-list]");
  CONFIG.flavors.forEach(function (f) {
    var row = document.createElement("div");
    row.className = "uwb-row";
    row.innerHTML =
      '<img class="uwb-thumb" data-uwb-thumb="' + f.id + '" src="' + (f.image || CONFIG.image) + '" alt="' + f.name + ' waffle" loading="lazy">' +
      '<div class="uwb-flavor"><div class="uwb-flavor__name">' + f.name + '</div>' +
        '<div class="uwb-flavor__meta">One 80-pack</div></div>' +
      '<div class="uwb-step">' +
        '<button data-uwb-dec="' + f.id + '" aria-label="Decrease ' + f.name + '">\u2212</button>' +
        '<input type="number" min="0" value="0" data-uwb-qty="' + f.id + '" aria-label="' + f.name + ' quantity">' +
        '<button data-uwb-inc="' + f.id + '" aria-label="Increase ' + f.name + '">+</button>' +
      '</div>';
    list.appendChild(row);
  });

  // Volume tier cards (one per tier) -- mirrors the app's Buy 1 / Buy 5 breakdown
  var tiersWrap = root.querySelector("[data-uwb-tiers]");
  CONFIG.tiers.forEach(function (t, i) {
    var card = document.createElement("div");
    card.className = "uwb-tiercard";
    card.setAttribute("data-uwb-tiercard", t.min);
    var pct = Math.round((1 - t.price / CONFIG.basePrice) * 100);
    var sub = i === 0
      ? "Any 1\u20134 80-packs"
      : "Mix any " + t.min + (CONFIG.tiers[i + 1] ? "\u2013" + (CONFIG.tiers[i + 1].min - 1) : "+") + " 80-packs";
    var priceHtml = t.price < CONFIG.basePrice
      ? '<s>' + money(CONFIG.basePrice) + '</s>' + money(t.price)
      : money(t.price);
    card.innerHTML =
      '<div class="uwb-tiercard__l">' +
        '<span class="uwb-tiercard__dot"></span>' +
        '<div>' +
          '<div class="uwb-tiercard__name">' + (i === 0 ? "Buy 1" : "Buy " + t.min) +
            (pct > 0 ? ' <span class="uwb-tiercard__badge">Save ' + pct + '%</span>' : '') + '</div>' +
          '<div class="uwb-tiercard__sub">' + sub + '</div>' +
        '</div>' +
      '</div>' +
      '<div class="uwb-tiercard__price">' + priceHtml + '<span style="font-weight:500;font-size:11px;color:var(--uwb-muted)">per pack</span></div>';
    tiersWrap.appendChild(card);
  });

  // ---- Rendering ------------------------------------------------------------
  function render() {
    var n = totalBoxes();
    var unit = unitPriceFor(n);
    var nt = nextTier(n);

    var msg = root.querySelector("[data-uwb-msg]");
    if (n === 0) {
      msg.innerHTML = "Add <b>5 80-packs</b> to unlock " + money(8000) + "/pack.";
    } else if (nt) {
      var need = nt.min - n;
      msg.innerHTML = "Add <b>" + need + " more</b> to unlock <b>" + money(nt.price) + "/pack</b>.";
    } else {
      msg.innerHTML = "\uD83C\uDF89 You\u2019ve unlocked the best price \u2014 <b>" + money(unit) + "/pack</b>.";
    }

    // progress fill: 0 at 0 boxes, 50% at 4, 100% at 8+
    var pct;
    if (n <= 0) pct = 0;
    else if (n < 5) pct = (n / 5) * 100;
    else pct = 100;
    root.querySelector("[data-uwb-fill]").style.width = pct + "%";

    [1, 5].forEach(function (m) {
      var t = root.querySelector('[data-uwb-tick="' + m + '"]');
      if (t) t.classList.toggle("is-hit", n >= m);
    });

    // Highlight the currently-active volume tier card
    var activeMin = CONFIG.tiers[0].min;
    CONFIG.tiers.forEach(function (t) { if (n >= t.min) activeMin = t.min; });
    if (n === 0) activeMin = null;
    CONFIG.tiers.forEach(function (t) {
      var card = root.querySelector('[data-uwb-tiercard="' + t.min + '"]');
      if (card) card.classList.toggle("is-active", t.min === activeMin);
    });

    // "Your mix" breakdown: exactly which flavors and counts make up the volume
    var mixEl = root.querySelector("[data-uwb-mix]");
    var lines = CONFIG.flavors
      .filter(function (f) { return (qty[f.id] || 0) > 0; })
      .map(function (f) {
        return '<div class="uwb-mix__line"><span>' + f.name + '</span><span>' +
          qty[f.id] + " \u00d7 " + money(unit) + " = " + money(unit * qty[f.id]) + "</span></div>";
      });
    if (!lines.length) {
      mixEl.innerHTML =
        '<div class="uwb-mix__head"><span class="uwb-mix__title">Your mix</span></div>' +
        '<div class="uwb-mix__empty">Add any flavors below \u2014 they all count toward your volume tier.</div>';
    } else {
      mixEl.innerHTML =
        '<div class="uwb-mix__head"><span class="uwb-mix__title">Your mix</span>' +
          '<span class="uwb-mix__count">' + n + (n === 1 ? " 80-pack" : " 80-packs") + ' \u00b7 ' + money(unit) + '/pack</span></div>' +
        lines.join("") +
        '<div class="uwb-mix__total"><span>Total</span><span>' + money(unit * n) + '</span></div>';
    }

    root.querySelector("[data-uwb-boxes]").textContent = n + (n === 1 ? " 80-pack" : " 80-packs");
    var unitEl = root.querySelector("[data-uwb-unit]");
    if (unit < CONFIG.basePrice && n > 0) {
      unitEl.innerHTML = "<s>" + money(CONFIG.basePrice) + "</s>" + money(unit) + "/pack";
    } else {
      unitEl.textContent = money(CONFIG.basePrice) + "/pack";
    }

    var save = (CONFIG.basePrice - unit) * n;
    var sEl = root.querySelector("[data-uwb-savings]");
    sEl.textContent = save > 0 ? "You save " + money(save) + " \u00b7 " + money(unit * n) + " total" : "";

    root.querySelector("[data-uwb-dockcount]").textContent = n;

    CONFIG.flavors.forEach(function (f) {
      var input = root.querySelector('[data-uwb-qty="' + f.id + '"]');
      if (input && String(qty[f.id]) !== input.value) input.value = qty[f.id];
    });
  }

  // ---- Events ---------------------------------------------------------------
  // Optimistic edit: update the stepper immediately, then push to the cart.
  function setQty(id, v) { qty[id] = Math.max(0, v | 0); render(); schedulePush(id); }

  root.addEventListener("click", function (e) {
    var inc = e.target.closest("[data-uwb-inc]");
    var dec = e.target.closest("[data-uwb-dec]");
    if (inc) { var i = +inc.getAttribute("data-uwb-inc"); setQty(i, (qty[i] || 0) + 1); }
    if (dec) { var d = +dec.getAttribute("data-uwb-dec"); setQty(d, (qty[d] || 0) - 1); }
    if (e.target.closest("[data-uwb-open]")) open();
    if (e.target.closest("[data-uwb-min]")) minimize();
    if (e.target.closest("[data-uwb-close]")) close();
    if (e.target.closest("[data-uwb-view]")) openNativeDrawer();
  });
  root.addEventListener("change", function (e) {
    var q = e.target.closest("[data-uwb-qty]");
    if (q) setQty(+q.getAttribute("data-uwb-qty"), +q.value);
  });

  function persistState(s) {
    try { if (s) sessionStorage.setItem("uwbm_state", s); else sessionStorage.removeItem("uwbm_state"); } catch (e) {}
  }
  function open() { root.hidden = false; root.removeAttribute("data-uwb-dismissed"); root.setAttribute("data-open", ""); persistState("open"); }
  function minimize() { root.hidden = false; root.removeAttribute("data-open"); persistState("min"); } // collapse to launcher tab; stays put until a real add or a manual open
  function close() { root.removeAttribute("data-open"); root.setAttribute("data-uwb-dismissed", ""); root.hidden = true; persistState("dismissed"); }

  // ---- Live cart editor: steppers mirror the cart; edits push to the cart ---
  var addingSelf = false;      // guard so our own writes don't re-trigger sync
  var cartQty = {};            // last server-confirmed qty per variant
  CONFIG.flavors.forEach(function (f) { cartQty[f.id] = 0; });
  var pushTimers = {};         // debounce timers per variant
  var pushBusy = 0;            // count of in-flight cart writes

  function hasPendingPush() {
    if (pushBusy > 0) return true;
    for (var k in pushTimers) { if (pushTimers[k]) return true; }
    return false;
  }

  // Debounce edits so rapid +/- clicks collapse into a single cart write.
  function schedulePush(id) {
    if (pushTimers[id]) clearTimeout(pushTimers[id]);
    pushTimers[id] = setTimeout(function () {
      pushTimers[id] = null;
      pushCartQty(id);
    }, 350);
  }

  // Reconcile one variant's cart line with the stepper's current value.
  function pushCartQty(id) {
    var target = Math.max(0, qty[id] | 0);
    var base = Math.max(0, cartQty[id] | 0);
    if (target === base) return;

    addingSelf = true; pushBusy++;
    window.__uwbmSelfAddAt = Date.now();

    var req;
    if (target > base) {
      // add the difference (works whether or not a line already exists)
      req = fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: id, quantity: target - base })
      });
    } else {
      // set an existing line to an absolute (lower) quantity; 0 removes it
      req = fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: String(id), quantity: target })
      });
    }

    req.then(function (r) { if (!r.ok) throw new Error("cart write failed"); return r.json(); })
      .then(function () {
        cartQty[id] = target;
        refreshNativeCartUI();  // repaint the theme drawer/count
        pullCart(false);        // reconcile steppers with the true server cart
      })
      .catch(function () {
        // revert the optimistic edit on failure
        qty[id] = cartQty[id] || 0;
        render();
      })
      .then(function () {
        pushBusy = Math.max(0, pushBusy - 1);
        setTimeout(function () { if (!hasPendingPush()) addingSelf = false; }, 600);
      });
  }

  // ---- Nudge the store's own (native) cart UI to re-read the server cart ----
  // A raw /cart/add|change won't update the theme drawer/count, so we ask the
  // theme helper (or fall back to the Section Rendering API) to repaint.
  function refreshNativeCartUI() {
    try {
      if (window.SHTHelper && typeof window.SHTHelper.forceUpdateCartStatus === "function") {
        window.SHTHelper.forceUpdateCartStatus();
      } else {
        renderCartSections();
      }
    } catch (e) {
      renderCartSections();
    }
  }

  // Fallback refresh via Shopify's Section Rendering API when no theme helper
  // is present: fetch the drawer + header sections and swap their markup in.
  function renderCartSections() {
    var targets = [];
    var drawer = document.getElementById("shtCartDrawer");
    var count = document.querySelector(".header__cart-count");
    [drawer, count].forEach(function (el) {
      if (!el) return;
      var sec = el.closest("[id^='shopify-section-']");
      if (sec) {
        var id = sec.id.replace("shopify-section-", "");
        if (targets.indexOf(id) === -1) targets.push(id);
      }
    });
    if (!targets.length) return;
    fetch("/?sections=" + encodeURIComponent(targets.join(",")), {
      headers: { "Accept": "application/json" }
    })
      .then(function (r) { return r.json(); })
      .then(function (map) {
        Object.keys(map).forEach(function (id) {
          var host = document.getElementById("shopify-section-" + id);
          if (host && typeof map[id] === "string") host.innerHTML = map[id];
        });
      })
      .catch(function () {});
  }

  // ---- Pull the live cart into the steppers (cart -> widget sync) -----------
  // Reads /cart.js, sets each flavor's stepper to its true cart quantity, and
  // (when asked) reopens the panel if THIS product's total went up.
  function pullCart(popIfIncreased) {
    if (hasPendingPush()) return; // don't clobber an in-progress local edit
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) ? cart.items : [];
        var byId = {};
        CONFIG.flavors.forEach(function (f) { byId[f.id] = 0; });
        items.forEach(function (it) {
          var vid = it.variant_id || it.id;
          for (var i = 0; i < CONFIG.flavors.length; i++) {
            if (String(CONFIG.flavors[i].id) === String(vid)) {
              byId[CONFIG.flavors[i].id] += (it.quantity || 0);
            }
          }
        });
        if (hasPendingPush()) return; // re-check: a local edit may have started
        var n = 0;
        CONFIG.flavors.forEach(function (f) {
          qty[f.id] = byId[f.id];
          cartQty[f.id] = byId[f.id];
          n += byId[f.id];
        });
        var prev = 0;
        try { prev = parseInt(sessionStorage.getItem("uwbm_qty") || "0", 10) || 0; } catch (e) {}
        try { sessionStorage.setItem("uwbm_qty", String(n)); } catch (e) {}
        render();
        if (popIfIncreased && n > prev) open();
      })
      .catch(function () {});
  }

  // Open the theme's native cart drawer by clicking its trigger control.
  function openNativeDrawer() {
    var trigger = document.querySelector(
      ".js-cart-drawer-trigger, [aria-controls='shtCartDrawer'], .js-header-cart-status-btn"
    );
    if (trigger) { try { trigger.click(); } catch (e) {} }
  }

  // ---- Refresh live variant data (keeps IDs/prices current) -----------------
  function refreshProduct() {
    fetch("/products/" + CONFIG.handle + ".js")
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (!p || !p.variants) return;
        CONFIG.basePrice = p.price || CONFIG.basePrice;
        if (p.featured_image) CONFIG.image = (p.featured_image.indexOf("//") === 0 ? "https:" : "") + p.featured_image;
        var byName = {};
        p.variants.forEach(function (v) { byName[v.title] = v; });
        CONFIG.flavors = CONFIG.flavors.map(function (f) {
          var v = byName[f.name];
          if (!v) return f;
          var img = (v.featured_image && v.featured_image.src) || f.image;
          return { name: f.name, id: v.id, image: img };
        }).filter(function (f) { var v = byName[f.name]; return !v || v.available !== false; });
        // rebuild qty + cart maps against the live variant IDs
        var nq = {}, nc = {};
        CONFIG.flavors.forEach(function (f) { nq[f.id] = qty[f.id] || 0; nc[f.id] = cartQty[f.id] || 0; });
        qty = nq; cartQty = nc;
        // keep flavor row thumbnails in sync with live variant images
        var thumbs = root.querySelectorAll(".uwb-thumb");
        if (thumbs.length === CONFIG.flavors.length) {
          CONFIG.flavors.forEach(function (f, i) { if (f.image) thumbs[i].src = f.image; });
        }
        pullCart(false); // reseed steppers now that variant IDs are live
      })
      .catch(function () {});
  }

  // ---- Trigger: keep steppers in step with cart writes from anywhere --------
  function onCartMutated() {
    // Any cart write we didn't initiate (native cart, PDP, another widget):
    // pull the live cart into the steppers and reopen only if OUR total rose.
    pullCart(true);
  }

  var CART_MUTATE_RX = /\/cart\/(add|change|update|clear)(\.js)?($|\?)/;

  // Wrap fetch to catch AJAX cart writes across the whole storefront
  if (typeof window.fetch === "function") {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = (typeof input === "string") ? input : (input && input.url) || "";
      var isMutate = CART_MUTATE_RX.test(url);
      var p = _fetch.apply(this, arguments);
      if (isMutate && !addingSelf) {
        p.then(function () { setTimeout(onCartMutated, 60); }).catch(function () {});
      }
      return p;
    };
  }

  // Wrap XMLHttpRequest for themes/apps that write the cart via XHR
  (function () {
    var _open = XMLHttpRequest.prototype.open;
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__uwbIsMutate = CART_MUTATE_RX.test(url || "");
      return _open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this.__uwbIsMutate) {
        this.addEventListener("load", function () {
          if (addingSelf) return;
          setTimeout(onCartMutated, 60);
        });
      }
      return _send.apply(this, arguments);
    };
  })();

  // Expose manual control (useful for testing / theme buttons)
  window.UnTappedMapleaidBuilder = {
    open: function () { open(); },
    minimize: function () { minimize(); },
    close: function () { close(); },
    config: CONFIG
  };

  // ---- Live sync: seed from the cart on load, then poll while visible -------
  render();
  refreshProduct();
  pullCart(false); // seed steppers from the current cart immediately

  setInterval(function () {
    if (root.hidden) return;              // no work while fully hidden
    if (addingSelf || hasPendingPush()) return; // don't fight a local edit
    pullCart(false);
  }, 2500);
})();